import { render, staticRenderFns } from "./listPreCotacoes.vue?vue&type=template&id=51267d25&"
import script from "./listPreCotacoes.vue?vue&type=script&lang=js&"
export * from "./listPreCotacoes.vue?vue&type=script&lang=js&"
import style0 from "./listPreCotacoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports